import { Box, styled, Typography } from '@material-ui/core';

export const Container = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  marginTop: 32,
});

export const Title = styled(Typography)({
  fontFamily: 'GT Walsheim',
  fontWeight: 700,
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '-0.02em',
});

export const LinesContainer = styled(Box)({
  width: '100%',
  height: 8,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

export const Line = styled(Box)({
  flex: 1,
  height: 8,
  borderRadius: 9999,
});
